<script setup lang="ts"></script>

<template>
  <div class="toast-item">
    <slot/>
  </div>
</template>

<style lang="scss" scoped>
.toast-item {
  background: rgba($color-neutral-100, 0.8);
  text-align: center;
  white-space: nowrap;
  height: 32px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
